import Cookie from "js-cookie";
import Vue from "vue";
import URI from "urijs";
import { APIgetLevelList, ApiLogin, ApiUserInfo, ApiMemberPermission2, ApigetMemberSignInRecord, ApigetMemberSignIn, ApigetSignInLogcStatisticsData, ApigetIntegralBalance, ApigetUserBalance, ApigetNoReadMsgCount, ApiNotReadCount, ApiQueryPageFriendApplyLog, ApigetProxyRp } from "@api/service";
import * as Time from "~/assets/libs/timeOptions";
import { i } from "mathjs";
export default {
    namespaced: true,
    state: {
        //账变类型
        recordType: [],
        regloadingState: 0, //注册页0未加载 1 加载中 2 加载成功 3 加载失败
        userInfo: {},
        balance: "",
        balanceLoading: false,
        integralBalance: "",
        token: "",
        noReadMsgCount: 0,
        NoReadMsgCountTimer: null,
        imRecent: [], //IM最近消息
        imFriendApplyLog: [], //im好友申请
        balanceTimer: null,
        balanceLoadingTimer: null,
        integralBalanceTimer: null,
        levelList: "", //会员等级列表
        showReadMsg: false, //未读消息是否弹框
        showMsgModal: false, //消息弹框
        showOffLineAlert: false, //掉线消息提示框
        lowerList: [], //下级列表
        recordFilter: "",
        showAccount: true,
        showBalance: true,
        //投注记录查询条件
        betRecordQuery: {
            dateFilter: [],
            dateIndex: 0,
            popDateIndex: 0,
            listIndex: "",
            isQueryLower: 0,
            maOn: "",
            status: "",
            // endDate: Time.Format(Time.dateToday(), "yyyy-MM-dd"),
            // startDate: Time.Format(Time.dateToday(), "yyyy-MM-dd"),
            // lotteryCode: "",
            // page: 1,  //这个就不存了
        },
        userLevelList: [],
        isFirstMyNotLogin: false,
        ProxyRpData: {},//返点数据
    },
    mutations: {
        setRegloadingState(state, payload) {
            state.regloadingState = payload
        },
        switchAccountStatu(state, arr) {
            state.showAccount = !state.showAccount;
        },
        switchBalanceStatu(state, arr) {
            state.showBalance = !state.showBalance;
        },
        setRecordType(state, arr) {
            state.recordType = arr;
        },
        setUserInfo(state, payload) {
            state.balance = payload.balance;
            state.userInfo = { ...payload };
            Cookie.set("USERINFO", state.userInfo);
        },
        setBalance(state, payload) {
            state.balance = payload;
            state.userInfo.balance = payload;
            Cookie.set("USERBALANCE", payload);
        },
        setBalanceLoading(state, payload) {
            state.balanceLoading = payload;
        },
        setIntegralBalance(state, payload) {
            state.integralBalance = payload;
            Cookie.set("USERINTEGRALBALANCE", payload);
        },
        setToken(state, payload) {
            state.token = payload;
            if (payload == "") {
                Cookie.set("TOKEN", "");
            }
        },
        setNoReadMsgCount(state, payload) {
            state.noReadMsgCount = payload;
        },
        setImRecent(state, payload) {
            state.imRecent = payload;
        },
        setImFriendApplyLog(state, payload) {
            state.imFriendApplyLog = payload
        },
        clearbalanceTimer(state) {
            clearInterval(state.balanceTimer);
        },
        setImNotReadMsgcount(state) {
            state.imNotReadMsgcount = state
        },
        setImContactNotReadCont(state) {
            state.imContactNotReadCont = state
        },
        clearintegralBalanceTimer(state) {
            clearInterval(state.integralBalanceTimer);
        },
        setlevelList(state, payload) {
            state.levelList = payload;
        },
        setShowReadMsg(state, payload) {
            state.showReadMsg = payload;
        },
        setShowMsgModal(state, payload) {
            state.showMsgModal = payload;
        },
        setShowOffLineAlert(state, payload) {
            state.showOffLineAlert = payload
        },
        updateUserInfo(state, info) {
            let t = Object.assign({}, { ...state.userInfo }, { ...info });
            Vue.set(state, "userInfo", { ...t });
            console.warn(state);
            try {
                Cookie.set("USERINFO", JSON.stringify(state.userInfo));
            } catch (e) { }
        },
        setLowerList(state, payload) {
            state.lowerList = payload;
        },
        updateRecordFilter(state, payload) {
            state.recordFilter = payload;
        },
        updateBetRecordQuery(state, payload) {
            let t = Object.assign({}, { ...state.betRecordQuery }, { ...payload });
            // Vue.set(state, "betRecordQuery", { ...t });
            state.betRecordQuery = t;
            console.log(state.betRecordQuery);
        },
        clearBetRecordQuery(state) {
            let q = {
                dateFilter: [],
                dateIndex: 0,
                popDateIndex: 0,
                listIndex: "",
                isQueryLower: 0,
                maOn: "",
                status: "",
            };
            state.betRecordQuery = Object.assign({}, q);
        },
        setUserLevelList(state, param) {
            param.forEach((item, index) => item.index = index + 1); //新增，把数组的index放进参数，用作用户等级根据id显示的参数
            state.userLevelList = param
        },
        setIsFirstMyNotLogin(state, payload) {
            state.isFirstMyNotLogin = payload
        }
    },
    actions: {
        getUserLevelList({
            commit
        }) {
            return new Promise((resolve, reject) => {
                APIgetLevelList().then((res) => {
                    if (res.code == "12200") {
                        commit('setUserLevelList', res.data)

                        resolve(res.data);
                    }
                    reject(res);
                });
            })
        },
        initStateByUrlParameter({ commit }) {
            //根据url 参数获取token
            return new Promise((resolve, reject) => {
                const parameterTokenValue = new URI().search(true)["tk"];
                const showBottomTab = new URI().search(true)["showBottomTab"] == "false" ? false : true;
                const showHeader = new URI().search(true)["showHeader"] == "false" ? false : true;
                const isInApp = new URI().search(true)["isInApp"] == "true" ? true : false;

                parameterTokenValue && commit("setToken", parameterTokenValue);
                commit("app/setshowBottomTab", showBottomTab, { root: true });
                commit("app/setHeaderVisible", showHeader, { root: true });
                commit("app/setIsInApp", isInApp, { root: true });
                resolve();
            });
        },
        login({ commit, dispatch }, param) {
            return new Promise((resolve, reject) => {
                ApiLogin(param).then((res) => {
                    if (res.code == "12200") {
                        // commit('setUserInfo',res.data)

                        dispatch("getPersonalInfo");
                        dispatch("getProxyRp");//获取返点信息
                        // dispatch('message/getMeesageByPage','',{root:true})
                        dispatch("loopGetNoReadMsgCount");
                        // commit("message/setShowHomePop", true,{root:true});  //首页弹框公告
                        commit("sysParameter/setShowDownBar", true, { root: true });
                        commit("sysParameter/setShowSignEntry", true, { root: true });

                        resolve(res);
                    }
                    reject(res);
                });
            });
        },
        loopGetNoReadMsgCount({ state, dispatch }) {
            clearInterval(state.NoReadMsgCountTimer);

            dispatch("getNoReadMsgCount");

            state.NoReadMsgCountTimer = setInterval(() => {
                let token = state.token || Cookie.get('TOKEN')
                if (token) {
                    dispatch("getNoReadMsgCount");
                }
            }, 20000);
        },
        getNoReadMsgCount({ commit, state, dispatch }, param = true) {
            //获取个人站内信未读数量
            ApigetNoReadMsgCount().then((res) => {
                if (res.code == "12200") {
                    commit("setNoReadMsgCount", res.data.count);
                    // console.log('res.data.count',res.data.count)
                    // console.log('res.data.isPop :', res.data.isPop);

                    let path = window.document.location.hash.includes("message");

                    if (path) {
                        commit("setShowReadMsg", false);
                    } else {
                        if (res.data.isPop) {
                            commit("setShowReadMsg", true);
                        }
                    }
                }
            });
        },
        getImRecent({ commit }) {
            return new Promise(async (resolve, reject) => {
                ApiNotReadCount().then((res) => {
                    if (res.code == '12200') {
                        commit('setImRecent', res.data)
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch((e) => {
                    reject(e)
                })
            })
        },
        getImFriendApplyLog({ commit }) {
            return new Promise(async (resolve, reject) => {
                ApiQueryPageFriendApplyLog({
                    limit: 300,
                    page: 1
                }).then((res) => {
                    if (res.code == '12200') {
                        commit('setImFriendApplyLog', res.data.list)
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch((e) => {
                    reject(e)
                })
            })
        },
        getPersonalInfo({ dispatch }) {
            return new Promise(async (resolve, reject) => {
                //获取个人信息
                await dispatch("getUserInfo");
                //获取个人余额
                await dispatch("getBalance");
                resolve(true);
            });
        },
        getUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                Promise.all([ApiUserInfo(), ApiMemberPermission2()]).then((res) => {
                    if (res[0].code == "12200" && res[1].code == "12200") {
                        // console.log(res.data)
                        const data = Object.assign({}, res[0].data, res[1].data)
                        commit("setUserInfo", data);
                        try {
                            Cookie.set("USERINFO", JSON.stringify(data));
                        } catch (e) {
                            console.warn(e);
                        }
                        resolve(data);
                    } else if (res[0].code = ! "12200") {
                        reject(res[0]);
                    } else if (res[1].code = ! "12200") {
                        reject(res[1]);
                    }
                });
            });
        },
        getBalance({ commit, state }) {
            return new Promise((resolve, reject) => {
                commit("setBalanceLoading", true)
                clearInterval(state.balanceTimer);
                ApigetUserBalance().then((res) => {
                    if (res.code == "12200") {
                        commit("setBalance", res.data.balance);
                        resolve(res.data.balance);
                    }
                    state.balanceLoadingTimer = setTimeout(() => {
                        commit("setBalanceLoading", false)
                        clearTimeout(state.balanceLoadingTimer);
                    }, 500);
                    resolve(state.balance);
                });

                state.balanceTimer = setInterval(() => {
                    ApigetUserBalance().then((res) => {
                        if (res.code == "12200") commit("setBalance", res.data.balance);
                    });
                }, 5000);
            });
        },
        getIntegralBalance({ commit, state }) {
            return new Promise((resolve, reject) => {
                clearInterval(state.integralBalanceTimer);
                ApigetIntegralBalance().then((res) => {
                    if (res.code == "12200") {
                        commit("setIntegralBalance", res.data.integralValue);
                        resolve(res.data.integralValue);
                    }
                    resolve(state.integralBalance);
                });

                // state.integralBalanceTimer = setInterval(() => {
                //     ApigetIntegralBalance().then(res=>{
                //         if(res.code == '12200')
                //         commit('setIntegralBalance',res.data.integralValue)
                //     })
                // }, 15000);
            });
        },
        getMemberSignInRecord({ commit }, param) {
            return new Promise((resolve, reject) => {
                ApigetMemberSignInRecord(param).then((res) => {
                    if (res.code == "12200") {
                        resolve(res);
                    }
                    reject(res);
                });
            });
        },
        memberSignIn({ commit }, param) {
            return new Promise((resolve, reject) => {
                ApigetMemberSignIn(param).then((res) => {
                    if (res.code == "12200") {
                        resolve(res);
                    }
                    reject(res);
                });
            });
        },
        getSignInLogcStatisticsData({ commit }, param) {
            return new Promise((resolve, reject) => {
                ApigetSignInLogcStatisticsData(param).then((res) => {
                    if (res.code == "12200") {
                        resolve(res);
                    }
                    reject(res);
                });
            });
        },

        // 获取返点比例信息
        getProxyRp({ state }) {
            ApigetProxyRp().then(res => {
                // console.error(res, '防范点')
                if (res.code == '12200' && res.data) {
                    state.ProxyRpData = res.data
                }
            })
        }
    },
    getters: {
        userLevelList: state => state.userLevelList,
        getLevelById: state => id => state.userLevelList.find(item => item.levelId == id),
        firstLeve: state => state.userLevelList[0],
        userBalanceCut: (state, getters, rootState) => {
            const _appConfig = rootState.app.appConfig;
            const userBalance = state.balance;
            const len = _appConfig.balance_format ? _appConfig.balance_format.configValue.retention_length || 2 : 2;
            let rlen = len == 0 ? 0 : len + 1;
            let tstr = userBalance + "";
            let _pointIndex = tstr.indexOf(".");
            if (_pointIndex != -1) {
                tstr = userBalance + "00000";
            } else {
                tstr = userBalance + ".00000";
            }
            return tstr.substring(0, tstr.indexOf(".") + rlen);
        },
        getUserInfo(state) {
            let userInfo = "";
            try {
                if (JSON.stringify(state.userInfo) == "{}") {
                    let info = Cookie.get("USERINFO");
                    if (info) {
                        state.userInfo = JSON.parse(info);
                        userInfo = state.userInfo;
                    }
                } else {
                    userInfo = state.userInfo;
                }
            } catch (e) {
                console.warn(e);
                userInfo = {};
            }
            return userInfo;
        },
        getBalance(state) {
            let balance = "";
            try {
                if (state.balance.length == 0) {
                    balance = JSON.parse(Cookie.get("USERBALANCE"));
                    state.balance = balance;
                } else {
                    balance = state.balance;
                }
            } catch {
                balance = 0;
            }
            return balance;
        },
        getBalanceLoading(state) {
            return state.balanceLoading
        },
        getIntegralBalance(state) {
            let integralBalance = "";
            try {
                if (state.integralBalance.length == 0) {
                    integralBalance = JSON.parse(Cookie.get("USERINTEGRALBALANCE"));
                    state.integralBalance = integralBalance;
                } else {
                    integralBalance = state.integralBalance;
                }
            } catch {
                integralBalance = 0;
            }
            return integralBalance;
        },
        getUserToken(state) {
            let Token = "";
            try {
                if (state.token.length == 0) {
                    Token = Cookie.get("TOKEN");
                    state.token = Token || "";
                } else {
                    Token = state.token;
                }
            } catch {
                Token = "";
            }
            return Token;
        },
        getImRecentNoReadMsgNum(state) {
            let num = 0;
            state.imRecent.forEach(item => {
                num += item.notreadcount ? item.notreadcount : 0
            })
            return num
        },
        getImFriendApplyLogNoReadNum(state) {
            let num = 0;
            state.imFriendApplyLog.forEach(item => {
                num += item.isRead == 0 ? 1 : 0
            })
            return num
        }
    },
};
